import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Grid, Box, IconButton, alpha, MenuItem, Divider } from '@mui/material';
import { useTranslationContext } from '../../../../hooks/translations/translationsProvider';
import { Close as CloseIcon } from '@mui/icons-material';
import AccordionCustom from '../../../AccordionCustom/AccordionCustom';
import InsertByAdminUpdateUserTokensComponent from './UserBalances/Tokens/InsertByAdminUpdateUserTokensComponent';
import UserCredits from './UserBalances/Credits/UserCredits';
import { GREEN_MAIN, GREEN_LOGO, WHITE } from '../../../../theme/colors';

interface PrivateProps {
  userId: string;
  userName: string;
  isPrivate: boolean;
  userAddress: string;
  onBack: () => void;
}

const AdminBalancesUser: React.FC<PrivateProps> = ({userId, userName, isPrivate, userAddress, onBack}) => {  
  const { t } = useTranslationContext();
  const [mainError, setMainError] = useState<string | null>(null);

  useEffect(() => {
    // Scrolla verso l'alto
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      {/* Header with close button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3
        }}
      >
        <Box sx={{ flex: 1 }} />
        <Typography 
          variant="h3" 
          sx={{ 
            color: GREEN_MAIN, 
            paddingBottom: 2,
            margin: 0,
            textAlign: 'center',
            flex: 2
          }}
        >
          {isPrivate ? t("Utente Privato") : t("Azienda o Associazione")}
        </Typography>
        
        <IconButton 
          onClick={onBack} 
          sx={{
            color: GREEN_MAIN,
            '&:hover': {
              backgroundColor: 'transparent',
              color: GREEN_LOGO,
            },
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <CloseIcon sx={{
            fontSize: "24px",
            '&:hover': {
              fontWeight: 'bold'
            },
          }} />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* User Information */}
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h5" 
          gutterBottom 
          sx={{ 
            color: GREEN_MAIN, 
            fontWeight: 'bold',
            mb: 2
          }}
        >
          {t("Informazioni Utente")}
        </Typography>
        
        <Box sx={{ 
          backgroundColor: `${GREEN_LOGO}05`,
          border: `1px solid ${GREEN_LOGO}20`,
          borderRadius: '8px',
          padding: 3
        }}>
          <Box sx={{ mb: 2 }}>
            <Typography 
              sx={{ 
                color: GREEN_MAIN,
                fontSize: '1rem',
                fontWeight: 'bold',
                mb: 0.5
              }}
            >
              {t("Nome")}
            </Typography>
            <Typography 
              sx={{ 
                color: GREEN_MAIN,
                fontSize: '1.1rem'
              }}
            >
              {userName}
            </Typography>
          </Box>
          
          <Box>
            <Typography 
              sx={{ 
                color: GREEN_MAIN,
                fontSize: '1rem',
                fontWeight: 'bold',
                mb: 0.5
              }}
            >
              {t("Indirizzo")}
            </Typography>
            <Typography 
              sx={{ 
                color: GREEN_MAIN,
                fontSize: '1.1rem'
              }}
            >
              {userAddress}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Tokens Section */}
      <Box sx={{ mb: 3 }}>
        {/*<AccordionCustom summayTxt={t('Tokens ASSO')}>
          <InsertByAdminUpdateUserTokensComponent userId={userId}/>
        </AccordionCustom>*/}
        <InsertByAdminUpdateUserTokensComponent userId={userId} userName={userName}/>
      </Box>

      {/* Credits Section */}
      {/**<Box sx={{ mb: 3 }}>
        <AccordionCustom summayTxt={t('Crediti Utente')}>
          <UserCredits />
        </AccordionCustom>
      </Box>

      {/* Error Display */}
      {mainError && (
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="body2"
            color="error"
            sx={{
              maxHeight: '6.5em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 5,
              lineHeight: '1.3em',
              wordWrap: 'break-word',
              padding: 2,
              backgroundColor: 'rgba(244, 67, 54, 0.1)',
              border: '1px solid rgba(244, 67, 54, 0.3)',
              borderRadius: '4px'
            }}
          >
            {mainError}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default AdminBalancesUser;
